function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4999 5.07563V13.9844C20.4999 14.8132 20.1707 15.608 19.5846 16.1941C18.9986 16.7801 18.2037 17.1094 17.3749 17.1094H3.62491C2.79611 17.1094 2.00125 16.7801 1.4152 16.1941C0.829149 15.608 0.499908 14.8132 0.499908 13.9844V5.07563L10.1824 10.7731C10.2786 10.8299 10.3882 10.8598 10.4999 10.8598C10.6116 10.8598 10.7212 10.8299 10.8174 10.7731L20.4999 5.07563ZM17.3749 0.859375C18.1438 0.859254 18.8858 1.14263 19.4589 1.6553C20.032 2.16797 20.396 2.87393 20.4812 3.63812L10.4999 9.50937L0.518659 3.63812C0.603856 2.87393 0.967813 2.16797 1.5409 1.6553C2.11399 1.14263 2.85598 0.859254 3.62491 0.859375H17.3749Z",
  fill: "#fff"
});

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.83995461.svg";
export { ForwardRef as ReactComponent };